import { Paper, Dialog, DialogTitle, DialogContent, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import Draggable from "react-draggable";
import { v4 as uuid } from "uuid";
import { GheymatMantegheiModel } from "../../../Api/Models/GheymatMantegheiModel";
import MDBox from "../../../Components/MDBox";
import MDButton from "../../../Components/MDButton";
import MDInput from "../../../Components/MDInput";
import MDTypography from "../../../Components/MDTypography";
function PaperComponent(props: any) {
  return (
    <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}
export default function SelectGheymat(props: { open: boolean; setClose: any; onDone: any; handleClick: any }) {
  const [CatTitle, setCatTitle] = useState("");
  const [Shomal, setShomal] = useState("");
  const [Shargh, setShargh] = useState("");
  const [Gharb, setGharb] = useState("");
  const [Jnoob, setJnoob] = useState("");
  const [TitleRadif, setTitleRadif] = useState("");
  const [MetrajMaabar, setMetrajMaabar] = useState("");
  const [data, setData] = useState([]);
  const gheymatMantegheiModel = new GheymatMantegheiModel();
  const handleSearch = () => {
    gheymatMantegheiModel
      .GetSearch(CatTitle, Shomal, Shargh, Jnoob, Gharb, TitleRadif, MetrajMaabar)
      .then((r) => setData(r.data.data))
      .catch((r) => {});
  };
  useEffect(() => {
    return () => {
      setData([]);
    };
  }, [props.open]);

  return (
    <Dialog open={props.open} onClose={props.setClose} PaperComponent={PaperComponent} aria-labelledby="draggable-dialog-title">
      <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
        <MDTypography variant="h">جستجو قیمت منطقه ای</MDTypography>
      </DialogTitle>
      <DialogContent>
        <MDBox>
          <Grid container py={1} gap="15px 0" xs={12}>
            <Grid item xs={5} textAlign="center" alignSelf={"center"}>
              <MDTypography fontSize={"14px"} fontWeight="bold">
                نام منطقه
              </MDTypography>
            </Grid>
            <Grid item xs={6}>
              <MDInput size="small" fullWidth value={CatTitle} onChange={(e: any) => setCatTitle(e.target.value)} />
            </Grid>
            <Grid item xs={2} textAlign="center" alignSelf={"center"}>
              <MDTypography fontSize={"14px"} fontWeight="bold">
                شمال
              </MDTypography>
            </Grid>
            <Grid item xs={4}>
              <MDInput size="small" fullWidth value={Shomal} onChange={(e: any) => setShomal(e.target.value)} />
            </Grid>
            <Grid item xs={2} textAlign="center" alignSelf={"center"}>
              <MDTypography fontSize={"14px"} fontWeight="bold">
                شرق
              </MDTypography>
            </Grid>
            <Grid item xs={4}>
              <MDInput size="small" fullWidth value={Shargh} onChange={(e: any) => setShargh(e.target.value)} />
            </Grid>
            <Grid item xs={2} textAlign="center" alignSelf={"center"}>
              <MDTypography fontSize={"14px"} fontWeight="bold">
                جنوب
              </MDTypography>
            </Grid>
            <Grid item xs={4}>
              <MDInput size="small" fullWidth value={Jnoob} onChange={(e: any) => setJnoob(e.target.value)} />
            </Grid>
            <Grid item xs={2} textAlign="center" alignSelf={"center"}>
              <MDTypography fontSize={"14px"} fontWeight="bold">
                غرب
              </MDTypography>
            </Grid>
            <Grid item xs={4}>
              <MDInput size="small" fullWidth value={Gharb} onChange={(e: any) => setGharb(e.target.value)} />
            </Grid>
            <Grid item xs={2} textAlign="center" alignSelf={"center"}>
              <MDTypography fontSize={"14px"} fontWeight="bold">
                عنوان ردیف
              </MDTypography>
            </Grid>
            <Grid item xs={4}>
              <MDInput size="small" fullWidth value={TitleRadif} onChange={(e: any) => setTitleRadif(e.target.value)} />
            </Grid>
            <Grid item xs={2} textAlign="center" alignSelf={"center"}>
              <MDTypography fontSize={"14px"} fontWeight="bold">
                متراژ معبر
              </MDTypography>
            </Grid>
            <Grid item xs={4}>
              <MDInput size="small" fullWidth value={MetrajMaabar} onChange={(e: any) => setMetrajMaabar(e.target.value)} />
            </Grid>
            <Grid item xs={12} textAlign="center">
              <MDButton variant="outlined" color="secondary" fullWidth onClick={handleSearch}>
                جستجو
              </MDButton>
            </Grid>
          </Grid>
        </MDBox>
        <MDBox minHeight="40vh" maxHeight="40vh" sx={{ overflow: "auto" }} bgColor="#adaabb" mt={1} border="2px #5b5b5b solid">
          <MDBox bgColor="#a665c224" px={1}>
            <Grid container columns={9} textAlign="center">
              <Grid item xs={1}>
                <MDTypography fontSize={"14px"} borderRight={"1px #000 solid"}>
                  عنوان
                </MDTypography>
              </Grid>
              <Grid item xs={1}>
                <MDTypography fontSize={"14px"} borderRight={"1px #000 solid"}>
                  شمال
                </MDTypography>
              </Grid>

              <Grid item xs={1}>
                <MDTypography fontSize={"14px"} borderRight={"1px #000 solid"}>
                  شرق
                </MDTypography>
              </Grid>
              <Grid item xs={1}>
                <MDTypography fontSize={"14px"} borderRight={"1px #000 solid"}>
                  غرب
                </MDTypography>
              </Grid>
              <Grid item xs={1}>
                <MDTypography fontSize={"14px"} borderRight={"1px #000 solid"}>
                  جنوب
                </MDTypography>
              </Grid>
              <Grid item xs={2}>
                <MDTypography fontSize={"14px"} borderRight={"1px #000 solid"}>
                  عنوان ردیف
                </MDTypography>
              </Grid>
              <Grid item xs={1}>
                <MDTypography fontSize={"14px"} borderRight={"1px #000 solid"}>
                  متراژ
                </MDTypography>
              </Grid>
              <Grid item xs={1}>
                <MDTypography fontSize={"14px"}>قیمت</MDTypography>
              </Grid>
            </Grid>
          </MDBox>
          {data.length > 0 ? (
            data.map((data: any, index: number) => {
              return (
                <MDBox
                  bgColor={index % 2 === 0 ? "#dfdfdf" : "white"}
                  px={1}
                  key={uuid()}
                  onClick={() => {
                    props.handleClick(data);
                  }}
                  sx={{ ":hover": { background: "#9185c8" }, cursor: "pointer" }}
                >
                  <Grid container columns={9} textAlign="center">
                    <Grid item xs={1} borderRight={"1px #000 solid"}>
                      <MDTypography fontSize={"14px"}>{data.gheymatMantaghei.title ?? ""}</MDTypography>
                    </Grid>
                    <Grid item xs={1} borderRight={"1px #000 solid"}>
                      <MDTypography fontSize={"14px"}>{data.gheymatMantaghei.shomal ?? ""}</MDTypography>
                    </Grid>
                    <Grid item xs={1} borderRight={"1px #000 solid"}>
                      <MDTypography fontSize={"14px"}>{data.gheymatMantaghei.shargh ?? ""}</MDTypography>
                    </Grid>
                    <Grid item xs={1} borderRight={"1px #000 solid"}>
                      <MDTypography fontSize={"14px"}>{data.gheymatMantaghei.gharb ?? ""}</MDTypography>
                    </Grid>
                    <Grid item xs={1} borderRight={"1px #000 solid"}>
                      <MDTypography fontSize={"14px"}>{data.gheymatMantaghei.jonoob ?? ""}</MDTypography>
                    </Grid>
                    <Grid item xs={2} borderRight={"1px #000 solid"}>
                      <MDTypography fontSize={"14px"}>{data.title ?? ""}</MDTypography>
                    </Grid>
                    <Grid item xs={1} borderRight={"1px #000 solid"}>
                      <MDTypography fontSize={"14px"}>{data.metrajMabar ?? ""}</MDTypography>
                    </Grid>
                    <Grid item xs={1}>
                      <MDTypography fontSize={"14px"}>{data.gheymat ?? ""}</MDTypography>
                    </Grid>
                  </Grid>
                </MDBox>
              );
            })
          ) : (
            <MDBox bgColor="white" textAlign="center">
              <MDTypography fontSize="14px" fontWeight="bold">
                جستجو نتیجه ای نداشت
              </MDTypography>
            </MDBox>
          )}
        </MDBox>
      </DialogContent>
    </Dialog>
  );
}
